const parseVersionFloat = versionString => {
  let versionArray = ("" + versionString)
      .replace("-", ".")
      .replace(/[^0-9.]/g, "")
      .split("."),
    sum = 0;
  for (let i = 0; i < versionArray.length; ++i) {
    sum += Number(versionArray[i]) / Math.pow(10, i * 3);
  }
  return sum;
};

const parseApiVersion = versionApiString => {
  const splitVersion = versionApiString.split(".");
  let encoding = "";
  if (splitVersion.length === 4) {
    encoding = splitVersion.pop();
  }
  const version = splitVersion.join(".");
  return { version, encoding };
};

export { parseVersionFloat, parseApiVersion };
